import { useCloseButton } from '@mobile/views/Relation/Shared/Popup/builder/buttons/useCloseButton'
import { useNavigationSeparator } from '@mobile/views/Relation/Shared/Popup/builder/buttons/useNavigationSeparator'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import PossibleWicketPopupDetails from './PossibleWicketPopupDetails.vue'

export const PossibleWicketPopup = new PopupBuilder('Possible Wicket')
  .appendBody(PossibleWicketPopupDetails)
  .setNavigationButtons([
    ...useNavigationSeparator(4),
    useCloseButton({
      color: 'red',
      text: 'Close',
    }),
  ])
  .build()
